import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Radio: ComponentStyleConfig = {
  baseStyle: {
    control: {
      display: 'inline-flex',
      alignItems: 'center',
      width: '20px',
      height: '20px',
      borderWidth: '1px',
      borderRadius: '50%',
      borderColor: 'neutral.600',
      background: 'white',
      _hover: {
        borderColor: 'black',
      },
      _checked: {
        borderColor: 'neutral.600',
        background: 'white',
        _hover: {
          background: 'white',
          borderColor: 'black',
        },
        _before: {
          content: `""`,
          display: 'inline-block',
          position: 'relative',
          alignItems: 'center',
          w: '12px',
          h: '12px',
          borderRadius: '50%',
          background: 'primary.500',
        },
      },
    },
    label: {
      marginInlineStart: '8px',
      fontSize: 'md',
      lineHeight: '24px',
      fontWeight: 400,
      color: 'black',
    },
  },
};

export default Radio;
